import React from 'react';
// import Button from '../components/Button';
// import Card from '../components/Card';
import CustomerCard from '../components/CustomerCard';
// import LabelText from '../components/LabelText';
import Layout from '../components/layout/Layout';
import SplitSection from '../components/SplitSection';
// import StatsBox from '../components/StatsBox';
import customerData from '../data/customer-data';
// import HeroImage from '../svg/HeroImage';
// import SvgCharts from '../svg/SvgCharts';
import WhyC4 from '../svg/WhyC4';
import Collaborate from '../svg/Collaborate';
import Extended from '../svg/Extended'
import Remote from '../svg/Remote'
import Development from '../svg/Development'
import { AiFillCheckCircle } from "react-icons/ai";
import FAQ from '../components/FAQ'
import { CheckIcon } from '@heroicons/react/solid'
import { Helmet } from "react-helmet"
import './how-it-works.css'

const steps = [
  { id: '01', name: 'Gather Requirements',description: 'Sprint roadmap is a collective planning effort. Team members collaborate to clarify items and ensure shared understanding.', href: '#', status: 'current' },
  { id: '02', name: 'Design the architecture',description: 'Sprint roadmap is a collective planning effort. Team members collaborate to clarify items and ensure shared understanding.', href: '#', status: 'current' },
  { id: '03', name: 'Implementation', href: '#',description: 'Sprint roadmap is a collective planning effort. Team members collaborate to clarify items and ensure shared understanding.', status: 'current' },
  { id: '04', name: 'Tests', description: 'Sprint roadmap is a collective planning effort. Team members collaborate to clarify items and ensure shared understanding.',href: '#', status: 'current' },
  { id: '05', name: 'Maintain', description: 'Sprint roadmap is a collective planning effort. Team members collaborate to clarify items and ensure shared understanding.',href: '#', status: 'current' },
]

const Steps = () => {
  return (
    <>
    <h1 className="text-4xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-6xl text-center py-10">
            <span className="block text-indigo-600 xl:inline">How we develop software</span>
          </h1>
    <nav aria-label="Progress">
      <ol className="border border-indigo-600 rounded-md divide-y divide-gray-600 md:flex md:divide-y-0">
        {steps.map((step, stepIdx) => (
          <li key={step.name} className="relative md:flex-1 md:flex" style={{flexDirection: 'column', padding: '1rem'}}>
            {step.status === 'complete' ? (
              <a href={step.href} className="group flex items-center w-full">
                <span className="px-6 py-4 flex items-center text-sm font-medium">
                  <span className="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-indigo-600 rounded-full group-hover:bg-indigo-800">
                    <CheckIcon className="w-6 h-6 text-white" aria-hidden="true" />
                  </span>
                  <span className="ml-4 text-sm font-medium text-gray-900">{step.name}</span>
                </span>
              </a>
            ) : step.status === 'current' ? (
              <>
              <a href={step.href} className="px-6 py-4 flex items-center text-sm font-medium" aria-current="step">
                <span className="flex-shrink-0 w-10 h-10 flex items-center justify-center border-2 border-indigo-600 rounded-full">
                  <span className="text-indigo-600">{step.id}</span>
                </span>
                  <span className="ml-4 text-sm font-medium text-indigo-600">{step.name}</span>
              </a>
              <div style={{display: 'flex', flexDirection: 'column'}}>
                  <p className="ml-4 text-sm font-medium text-blue-600">{step.description}</p>
                </div>
              </>
            ) : (
                  <a href={step.href} className="group flex items-center">
                    <span className="px-6 py-4 flex items-center text-sm font-medium">
                      <span className="flex-shrink-0 w-10 h-10 flex items-center justify-center border-2 border-indigo-600 rounded-full group-hover:border-indigo-600">
                        <span className="text-gray-600 group-hover:text-gray-900">{step.id}</span>
                      </span>
                      <span className="ml-4 text-sm font-medium text-gray-600 group-hover:text-gray-900">{step.name}</span>
                    </span>
                  </a>
                )}

            {stepIdx !== steps.length - 1 ? (
              <>
                {/* Arrow separator for lg screens and up */}
                <div className="hidden md:block absolute top-0 right-0 h-full w-5" aria-hidden="true">
                  <svg
                    className="h-full w-full text-indigo-600"
                    viewBox="0 0 22 80"
                    fill="none"
                    preserveAspectRatio="none"
                  >
                    <path
                      d="M0 -2L20 40L0 82"
                      vectorEffect="non-scaling-stroke"
                      stroke="currentcolor"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </>
            ) : null}
          </li>
        ))}
      </ol>
    </nav>
    </>
  )
}

const Index = () => (
  <Layout>
    <Helmet>
          <meta charSet="utf-8" />
          <title>C4Scale - How it works</title>
          <meta name="description" content="Hire Remote Engineers From C4Scale !!!" />
        </Helmet>
    <SplitSection
      id="services"
      primarySlot={
        <div className="lg:pr-12 xl:pr-28">
          <h3 className="text-3xl font-semibold leading-tight">Why C4Scale</h3>
          <p className="mt-8 text-xl font-light leading-relaxed">
            We are a people-first company, passionate about building innovative software. 
Our motive is to bring opportunities across the globe to top talent. We do this by tapping into engineering talent nurturing them to do high impact, meaningful work.
          </p>
          <p className="mt-8 text-xl font-light leading-relaxed">
           Hire Remote Engineers From C4Scale !!!
          </p>
        </div>
      }
      secondarySlot={<WhyC4 />}
    />
    <section class="alternate-bg">
    <SplitSection
      reverseOrder
      primarySlot={
        <div className="lg:pl-12 xl:pl-28">
          <h3 className="text-3xl font-semibold leading-tight">
            <span className="underline-custom">Collaborating</span> with C4Scale
          </h3>
          <p className="mt-8 text-xl font-light leading-relaxed">
            Collaborating with C4Scale means that you trust us to deliver work well tested and on time. You believe in our agile teams that focus on delivering value &amp; impact for your business.
          </p>
        </div>
      }
      secondarySlot={<Collaborate />}
    />
    </section>
    <div className="wrapper">
        <header>Your collaboration with us can fall under the following categories.</header>
        <input type="radio" name="slider" defaultChecked id="home" />
        <input type="radio" name="slider" id="blog" />
        <input type="radio" name="slider" id="code" />
        <nav>
          <label htmlFor="home" className="home"><i className="fas fa-home" />Product Development Teams</label>
          <label htmlFor="blog" className="blog"><i className="fas fa-blog" />Extended Team</label>
          <label htmlFor="code" className="code"><i className="fas fa-code" />Remote/Onsite Teams</label>
          <div className="slider" />
        </nav>
        <section>
          <div className="content content-1">
            <SplitSection
      reverseOrder
      primarySlot={
        <div className="lg:pl-12 xl:pl-28">
          <h3 className="pb-10 text-3xl font-semibold leading-tight">
            Product Development Teams
          </h3>
          <p className="text-lg text-gray-600 leading-relaxed">
           This model is relevant if you’re an enterprise, entrepreneur or a start up with a high vision to build a product however you need a dedicated team to build it on your behalf. Some of the situations that leads to this model:
          </p>
          <p className="text-lg text-gray-600 leading-10">
           <ul>
                <li><AiFillCheckCircle style={{display: 'inline', marginRight: '10px', color: '#4199e1'}}/>You need to prototype an idea and find market fit</li>
                <li><AiFillCheckCircle style={{display: 'inline', marginRight: '10px', color: '#4199e1'}}/>You have a prototype and you want to build a complete product with a mobile app and/or a website, backend</li>
                <li><AiFillCheckCircle style={{display: 'inline', marginRight: '10px', color: '#4199e1'}}/>You need to scale from 0 to 1</li>
                <li><AiFillCheckCircle style={{display: 'inline', marginRight: '10px', color: '#4199e1'}}/>You need to scale from 1 to destination</li>
           </ul>
          </p>
        </div>
      }
      secondarySlot={<Development />}
    />
          </div>
          <div className="content content-2">
              <h2 class="text-3xl font-extrabold text-gray-900">Extended Team</h2>
            <p class="mt-4 text-lg text-gray-600">This model works if you have software development processes &amp; teams already in place and now you need to scale your teams. You are looking for specialists to fill in gaps in expertise/skills in your teams. This situation may arise if:</p>
            <SplitSection
      primarySlot={
        <div className="lg:pr-12 xl:pr-28">
          <p className="mt-8 text-lg text-gray-600 leading-relaxed">
            <ul>
                <li><AiFillCheckCircle style={{display: 'inline', marginRight: '10px', color: '#4199e1'}}/>You need short term contract positions to complete certain work</li>
                <li><AiFillCheckCircle style={{display: 'inline', marginRight: '10px', color: '#4199e1'}}/>You’ve budgeted constraints but need to scale the throughput and therefore need high quality expertise for a fair price</li>
                <li><AiFillCheckCircle style={{display: 'inline', marginRight: '10px', color: '#4199e1'}}/>You have shortage of talent supply</li>
            </ul>
        </p>
        <p className="text-lg text-gray-600 leading-relaxed">
        In this case, we support you to fulfill your needs by:
            <ul>
                <li><AiFillCheckCircle style={{display: 'inline', marginRight: '10px', color: '#4199e1'}}/>providing skilled, technology experts that have high industry standards</li>
                <li><AiFillCheckCircle style={{display: 'inline', marginRight: '10px', color: '#4199e1'}}/>Recruiting and filling these roles based on your requirements</li>
            </ul>
          </p>
        </div>
      }
      secondarySlot={<Extended />}
    />
     <div class="max-w-3xl py-10">
      <p class="mt-4 text-lg text-gray-600">This also means that you have complete control over the product architecture, SDLC processes, tooling, project delivery etc.</p>
    </div>
          </div>
          <div className="content content-3">
            <SplitSection
      id="services"
      primarySlot={
        <div className="lg:pr-12 xl:pr-28">
          <h3 className="text-3xl font-semibold leading-tight">Remote/Onsite Teams</h3>
          <p className="text-lg text-gray-600 leading-relaxed py-10">
           This model applies if you have long-term projects and want to have dedicated teams working on them. As an example a full stack team with front-end &amp; backend developers and a scrum master to drive development, test phases in an agile way & managing project delivery. This can be a self-sustaining remote team and flexible to work in times overlapping your timezone.
          </p>
          <p className="text-lg text-gray-600 leading-relaxed">
           You can consider this as your cross-functional team working along with other teams of yours. In this case there may be shared responsibility in owning from gathering requirements to architecture/design/implementation.
          </p>
        </div>
      }
      secondarySlot={<Remote />}
    />
          </div>
        </section>
      </div>
   
  
    {/* <div class="max-w-3xl mx-auto text-center">
      <p class="mt-4 text-lg text-gray-600">In this case, it is expected that you trust us to do the following:</p>
    </div> */}
    <section class="alternate-bg">
    <div className="stepsWrapper">
        {Steps()}
      </div>
      <br/>
    </section>
    {/* <div class="max-w-3xl mx-auto">
      <p class="mt-4 text-lg text-gray-600">We are your outsourced partner and bring your vision to life. You have complete ownership, copyrights of your product.</p>
      <p class="mt-4 text-lg text-gray-800">Support - <span class="mt-4 text-lg text-gray-600">We can custom build a support agreement as per your needs</span></p>
      <p class="mt-4 text-lg text-gray-800">Flexible hiring - <span class="mt-4 text-lg text-gray-600">You have 100% flexibility to replace, let go off an engineer. Of course, give us a month’s notice.</span></p>
    </div> */}
    <section id="testimonials" className="py-12">
      <div className="container mx-auto">
        <h1 className="text-4xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-6xl pb-4 sentence">
          <span className="block xl:inline">How to hire engineers and</span>{' '}
          <span className="block text-indigo-600 xl:inline pb-4"><span className="underline-custom">start engagement</span> with C4Scale</span>
        </h1>
        {/* <LabelText className="mb-8 text-gray-600 text-center">How do we start engagement (process flow)</LabelText> */}
        <div className="flex flex-col md:flex-row md:-mx-3" style={{flexWrap: 'wrap'}}>
          {customerData.map(customer => (
            <div key={customer.customerName} className="flex-1 px-3" style={{minWidth: '350px'}}>
              <CustomerCard customer={customer} />
            </div>
          ))}
        </div>
      </div>
    </section>
    <FAQ/>
  </Layout>
);

export default Index;
